/** SSWS org URL + token (browser sessionStorage only — per §5.3.1 SESSION_ONLY). */
const STORAGE_KEY = "idwiz.oktaSswsTenant";

export function readStoredSswsSession() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw);
    const orgUrl = o?.orgUrl != null ? String(o.orgUrl).trim() || null : null;
    const rawTok = o?.apiToken != null ? String(o.apiToken).trim() : "";
    const apiToken = rawTok || null;
    if (!orgUrl) return null;
    if (!apiToken) return { orgUrl, apiToken: null };
    return { orgUrl, apiToken };
  } catch {
    return null;
  }
}

export function writeStoredSswsSession(orgUrl, apiToken) {
  try {
    if (orgUrl?.trim() && apiToken?.trim()) {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ orgUrl: String(orgUrl).trim(), apiToken: String(apiToken).trim() }),
      );
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    /* ignore quota / private mode */
  }
}

/** After Okta returns 401 — keep org URL in the UI/storage but drop the token. */
export function writeStoredOrgOnly(orgUrl) {
  try {
    const o = orgUrl != null ? String(orgUrl).trim() : "";
    if (o) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ orgUrl: o, apiToken: "" }));
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    /* ignore */
  }
}

export function clearStoredSswsSession() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
